/* unplugin-vue-components disabled */import { render } from "./index-tag.vue?vue&type=template&id=02c50263&scoped=true"
import script from "./index-tag.vue?vue&type=script&lang=js"
export * from "./index-tag.vue?vue&type=script&lang=js"

import "./index-tag.vue?vue&type=style&index=0&id=02c50263&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/e-bike/e-bike-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02c50263"]])

export default __exports__